/**
 * Minimal markdown renderer for AI agent output (## headers, **bold**, - bullets,
 * numbered lines). Shared by the Prep Call panel, Deal Radar card, and Owner
 * Outreach drafts so every agent surface reads identically.
 */
export default function AgentMarkdown({ text }: { text: string }) {
  return (
    <div className="space-y-0.5">
      {text.split('\n').map((raw, i) => {
        const line = raw.trimEnd();
        if (line.startsWith('### ') || line.startsWith('## ')) {
          return (
            <p key={i} className="text-[11px] uppercase tracking-wider text-gray-400 font-semibold mt-5 mb-1.5 first:mt-0">
              {line.replace(/^#+\s*/, '')}
            </p>
          );
        }
        if (line.trim() === '') return <div key={i} className="h-1.5" />;
        const isBullet = /^[-•] /.test(line.trim());
        const text2 = isBullet ? line.trim().slice(2) : line;
        const parts = text2.split(/\*\*(.+?)\*\*/g).map((seg, j) =>
          j % 2 === 1 ? <strong key={j} className="font-semibold text-gray-900">{seg}</strong> : seg
        );
        if (isBullet) {
          return (
            <p key={i} className="text-sm text-gray-700 leading-relaxed flex gap-2">
              <span className="text-gray-300 shrink-0">•</span>
              <span>{parts}</span>
            </p>
          );
        }
        return <p key={i} className="text-sm text-gray-700 leading-relaxed">{parts}</p>;
      })}
    </div>
  );
}
